import { j as e } from "./atoms-v218.js";
import { forwardRef as u, useMemo as g } from "react";
import { Icon as d } from "./atoms-v217.js";
import { Text as h } from "./atoms-v243.js";
import { SearchBarWrapper as y, StyledSearchBar as S, IconButton as p, BackButtonIcon as v, SearchArea as $, SearchBarButton as m, SmallButtonContainer as f, SmallButtonRow as z, TagContainer as C, StyledTag as L } from "./atoms-v2734.js";
const b = u(
  ({
    colorTheme: i = "light",
    filterCount: c,
    isLoading: n,
    mainButtons: a,
    onBackButtonClick: o,
    onFilterClick: x,
    onLanguageAndCurrencyClick: j,
    size: s = "large"
  }, k) => {
    const r = g(() => [...a].sort((t, l) => t.isPrimary ? -1 : l.isPrimary ? 1 : 0), [a]);
    return /* @__PURE__ */ e.jsx(y, { $size: s, ref: k, children: /* @__PURE__ */ e.jsxs(S, { $size: s, children: [
      /* @__PURE__ */ e.jsx(
        p,
        {
          colorTheme: i,
          disabled: !o,
          onClick: o,
          shape: "pill",
          size: "small",
          variant: "ghost",
          children: /* @__PURE__ */ e.jsx(v, { $isVisible: !!o, name: "arrow-left", size: "small" })
        }
      ),
      /* @__PURE__ */ e.jsxs($, { $colorTheme: i, $size: s, children: [
        s === "small" && r.length > 0 ? /* @__PURE__ */ e.jsx(
          m,
          {
            $size: s,
            colorTheme: i,
            onClick: r[0].onClick,
            shape: "pill",
            size: "small",
            variant: "ghost",
            children: /* @__PURE__ */ e.jsxs(f, { children: [
              /* @__PURE__ */ e.jsx(
                h,
                {
                  colorTheme: i,
                  isSkeleton: n,
                  skeletonLineCount: 1,
                  skeletonLineHeight: 12,
                  skeletonLineWidth: 75,
                  type: "helper",
                  variant: "productive",
                  children: r[0].displayText
                }
              ),
              /* @__PURE__ */ e.jsx(z, { children: r.slice(1).map((t, l) => /* @__PURE__ */ e.jsx(
                h,
                {
                  colorTheme: i,
                  isSkeleton: n,
                  skeletonLineCount: 1,
                  skeletonLineHeight: 10,
                  skeletonLineWidth: 45,
                  type: "helper",
                  variant: "xs-productive",
                  children: t.displayText
                },
                `search-bar-small-button-${l}`
              )) })
            ] })
          }
        ) : /* @__PURE__ */ e.jsx(e.Fragment, { children: a.map((t, l) => /* @__PURE__ */ e.jsx(
          m,
          {
            $size: s,
            colorTheme: i,
            onClick: t.onClick,
            shape: "pill",
            size: "small",
            variant: "ghost",
            children: /* @__PURE__ */ e.jsx(
              h,
              {
                colorTheme: i,
                isSkeleton: n,
                skeletonLineCount: 1,
                skeletonLineHeight: 16,
                skeletonLineWidth: 125,
                type: "body",
                variant: "compact-productive",
                children: t.displayText
              }
            )
          },
          `search-bar-button-${l}`
        )) }),
        /* @__PURE__ */ e.jsxs(C, { $size: s, children: [
          /* @__PURE__ */ e.jsx(
            p,
            {
              colorTheme: i === "light" ? "dark" : "light",
              iconOnly: !0,
              onClick: x,
              shape: "pill",
              size: "small",
              variant: "primary",
              children: /* @__PURE__ */ e.jsx(d, { name: "settings-adjust", size: "small" })
            }
          ),
          c > 0 && /* @__PURE__ */ e.jsx(L, { colorTheme: i, size: "small", variant: "outline", children: c })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(
        p,
        {
          colorTheme: i,
          onClick: j,
          shape: "pill",
          size: "small",
          variant: "ghost",
          children: /* @__PURE__ */ e.jsx(d, { name: "wikis", size: "small" })
        }
      )
    ] }) });
  }
);
b.displayName = "SearchBar";
export {
  b as SearchBar
};
